import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff, BellRing } from "lucide-react";
import { pushSupported, getPushStatus, enablePush, disablePush, sendTestPush } from "@/lib/push";

export default function NotificationBell() {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [supported] = useState(pushSupported());

  useEffect(() => {
    if (!supported) return;
    getPushStatus().then((s) => setEnabled(!!s.enabled));
  }, [supported]);

  if (!supported) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) {
        await disablePush();
        setEnabled(false);
        toast.success("Desktop notifications turned off");
      } else {
        await enablePush();
        setEnabled(true);
        await sendTestPush().catch(() => {});
        toast.success("Desktop notifications enabled");
      }
    } catch (e) {
      toast.error(e?.message || "Could not update notifications");
    } finally {
      setBusy(false);
    }
  };

  const Icon = busy ? BellRing : enabled ? Bell : BellOff;

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid="notification-toggle"
      title={enabled ? "Desktop notifications on — click to turn off" : "Enable desktop notifications"}
      className={`h-8 w-8 flex items-center justify-center rounded-sm transition-colors disabled:opacity-50 ${
        enabled ? "text-zinc-900 bg-zinc-200" : "text-zinc-500 hover:bg-zinc-200 hover:text-zinc-900"
      } ${busy ? "animate-pulse" : ""}`}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}
